// @flow
import React from 'react'

type CurrentCrumbProps = {
  current: string
}

const CurrentCrumb = ({ current }: CurrentCrumbProps) => (
  <li className='breadcrumb'>
    <span>{current}</span>
  </li>
)

export default CurrentCrumb



// WEBPACK FOOTER //
// ./src/ui/lists/current-crumb.js